import * as React from "react";
import * as cls from "./CheckBox.module.scss";
export { CheckBox };
/**
 * Флажок.
 * 
 * Представляет элемент управления, который позволяет выбрать или снять флажок.
 * 
 * @summary Флажок.
 * @param {Object} props - Атрибуты элемента.
 * @param {React.RefObject} [props.inputRef] - Ссылка на элемент `input`.
 * @param {string} [props.id] - Идентификатор поля.
 * Задаёт атрибуты `name` и `id`.
 * @param {string} [props.label] - Название и описание поля.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {boolean} [props.required] - Обязательно.
 * @param {boolean} [props.disabled] - Неактивно.
 * @param {boolean} [props.uncontrolled] - Неуправляемый компонент.
 * @param {boolean} [props.autoComplete] - Разрешено ли автозаполнение.
 * @param {boolean} [props.value] - Значение.
 * @param {EventListener} [props.onChange] - Событие при изменении.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link ../frame/EventListener.js}
 * @see [Windows.UI.Xaml.Controls.CheckBox](https://learn.microsoft.com/ru-ru/uwp/api/windows.ui.xaml.controls.checkbox)
 * @see [Флажок](https://ru.wikipedia.org/wiki/Флажок_(интерфейс))
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function CheckBox(
  {
    inputRef,
    id,
    label,
    className,
    required,
    disabled,
    uncontrolled,
    autoComplete,
    value,
    onChange
  }) {
  let fullClassName = cls.checkbox;
  if (className) fullClassName += " " + className;
  const widgetRequired = required ?
    <span className={cls.checkbox_required}></span> :
    null;
  const widgetLabel = label ?
    <label htmlFor={id}>
      {widgetRequired}{label}
    </label> :
    null;
  return (
    <div className={fullClassName}>
      <input
        type="checkbox"
        ref={inputRef}
        id={id}
        name={id}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        checked={uncontrolled ? undefined : !!value}
        onChange={onChange}
        autoComplete="off" />
      {widgetLabel}
    </div>
  );
}
